import './App.css';
import Home from './components/Home';
import Navbar from './components/Navbar';
import Education from './components/Education';
import Project from './components/Project';
import Skills from './components/Skills';
import Contact from './components/Contact';
import Slider from './components/Slider';
import About from './components/About';


// import {
//   BrowserRouter as Router,
//   Routes ,
//   Route 
// } from "react-router-dom";




function App() {
  return (
   <div className='mainApp'>
           
    
  
      <Navbar/>
      <br></br>
      {/* <Slider></Slider> */}
      <Home/>
      <About/>
      <Education/>
      <Project/>
      <Skills/>
      <Contact/>

      {/* <BrowserRouter>
      <Navbar/>
      
      <Link to='#Education'
       
       
      {/* <Routes>
             <Route path="/" element={<Home/>}></Route>
             <Route path="Projects" element={<Project/>}/>
             <Route path="Education" element={<Education/>}/>
             <Route path="Skills" element={<Skills/>}/>
      </Routes> 
      </BrowserRouter> */}
    
    
    
     
   </div>
  );
}

export default App;

